import { yupResolver } from '@hookform/resolvers/yup';
import { Button } from '@mui/material';
import { useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { object, string } from 'yup';
import { ControlledInput, IParams, ISaveOrganisationType, Page, Section, Widget } from '../../../shared';
import { useOrganisationType, useSaveOrganisationType } from '../../hooks/organisation-type.hook';

export function OrganisationTypeEditPage() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { id } = useParams<keyof IParams>() as IParams;
    const { data } = useOrganisationType(id, { messages: { onGetErrorMessage: t('getOrganisationTypeError') } });

    const form = useForm<ISaveOrganisationType>({
        resolver: yupResolver(object().shape({ name: string().required() })),
        mode: 'all',
    });
    const { mutateAsync: saveOrganisationType } = useSaveOrganisationType();

    useEffect(() => {
        if (data) {
            form.reset(data);
        }
    }, [data, form]);

    const onSubmit = async (data: ISaveOrganisationType) => {
        await saveOrganisationType({
            data,
            messages: {
                onUpdateSuccessMessage: t('updateOrganisationTypeSuccess'),
                onUpdateErrorMessage: t('updateOrganisationTypeError'),
                onCreateSuccessMessage: t('createOrganisationTypeSuccess'),
                onCreateErrorMessage: t('createOrganisationTypeError'),
            },
        });
        navigate('/admin/organisation-types');
    };

    const actions = [
        <Button onClick={() => navigate('/admin/organisation-types')} color="secondary">
            {t('cancel')}
        </Button>,
        <Button type="submit" variant="contained" color="primary" onClick={form.handleSubmit(onSubmit)}>
            {t('save')}
        </Button>,
    ];

    return (
        <Page title={data?.name || t('newOrganisationType')} actions={actions} onBack={() => navigate(-1)}>
            <FormProvider {...form}>
                <form onSubmit={form.handleSubmit(onSubmit)}>
                    <Widget footer={[...actions].reverse()}>
                        <Section title={t('data')}>
                            <ControlledInput name="name" label={t('nameLabel')} required sx={{ width: '400px' }} />
                        </Section>
                    </Widget>
                </form>
            </FormProvider>
        </Page>
    );
}
